import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { RequestForm } from './RequestForm';
import { RequestsContainer, RequestsPreview, SocketPreview } from './styled';
export const APIFetcher = () => {
    const requestPreviewRef = useRef(null);
    const socketPreviewRef = useRef(null);
    const [socketListening, setSocketListening] = useState(false);
    useEffect(() => {
        if (!socketListening && socketPreviewRef && socketPreviewRef.current) {
            const container = socketPreviewRef.current;
            const events = new EventSource(`${process.env.REACT_APP_BACKEND_HOST}/sse`);
            events.onmessage = event => {
                const data = JSON.parse(event.data);
                container.innerText = `Last SSE message: \n\n${JSON.stringify(data, null, 4)}`;
            };
            setSocketListening(true);
        }
    }, [socketListening]);
    return (_jsxs(_Fragment, { children: [_jsxs(RequestsContainer, { children: [_jsx(RequestForm, { previewRef: requestPreviewRef }), _jsx(RequestsPreview, { ref: requestPreviewRef })] }), _jsx(RequestsContainer, { children: _jsx(SocketPreview, { ref: socketPreviewRef }) })] }));
};
